import Vue from 'vue';

function initialState() {
  return {
    WebsiteVendorsList: [],
    showEditVendorModal: false,
    CurrentVendorDetails: {},
    VendorDomainList: [],
    showVendorDomainsModal: false,
    CurrentVendor: {},
    AD_AccountSearchResults: [],
    showAddDealerToVendorModal: false,
    ActivePlatforms: [],
    showDeleteVendorModal: false,
    VendorListLoading: false,
    VendorModalType: "",
    ExistingDomains: [],
    viewOnlyPermissions: false
  }
}

const state = initialState();

const actions = {

  getAllVendors: function (context, data) {

    context.commit('updateVendorLoadingImg', true);
    return new Promise((resolve, reject) => {
      Vue.http.get('/websitevendors/all').then(function (data) {
        context.commit('updateVendorLoadingImg', false);
        context.commit('updateVendorsList', data.data.Data);
        resolve(data.data.Data);

      }).catch((error) => {
        reject(error);
        context.commit('updateVendorLoadingImg', false);
      });
    });
  },
  updateVendorDetails: function (context, vendorDetails) {
    //console.log("Updated : ", vendorDetails);
    return new Promise((resolve, reject) => {
      Vue.http.post('vendor/savewebsitevendor', vendorDetails).then(function (data) {
        resolve(data.data.Data);
      }).catch((error) => {
        reject(error)
      });
    });
  },
  viewVendorDomains: function (context, vendorId) {
    return new Promise((resolve, reject) => {
      Vue.http.get('/vendor/domains/' + vendorId).then(function (data) {
        context.commit('updateVendorDomainList', data.data.Data);
        resolve(data.data.Data);
      }).catch((error) => {
        reject(error)
      });
    });
  },
  searchAccounts: function (context, param) {
    return new Promise((resolve, reject) => {
      Vue.http.get('platform/searchdealers?accountId=' + param.accountId + '&term=' + param.searchTxt + '&internalOnly=' + param.interalOnly).then(function (data) {
        context.commit('updateSearchItems', data.data.Data);
        data.data.Data.forEach(function(account){
          account.LabelText = account.Account + " [" + account.AccountId + "]";
        });
        resolve(data.data.Data);
      }).catch((error) => {
        reject(error)
      });
    });
  },
  loadActiveDealersForAccount: function (context, accountId) {
    return new Promise((resolve, reject) => {
      Vue.http.get('account/platforms/' + accountId).then(function (data) {
        context.commit('updateExistignDomains', data.data.Data);
        resolve(data.data.Data);
      }).catch((error) => {
        reject(error)
      });
    });
  },
  loadExistingDomains: function (context, params) {
    if (params == null || params.AccountId < 1)
      reject(error);

    return new Promise((resolve, reject) => {
      Vue.http.get('domain/existingdomains?accountId=' + params.AccountId + '&platformId=' + params.PlatformId).then(function (data) {
        context.commit('updateExistignDomains', data.data.Data);
        resolve(data.data.Data);
      }).catch((error) => {
        reject(error)
      });
    });
  },
  verifyDomain: function (context, domain) {

    let searchRequest = {
      Domain: domain
    }
    return new Promise((resolve, reject) => {
      Vue.http.get('domain/verify?domain=' + domain).then(function (data) {
        resolve(data.data.Data);
      }).catch((error) => {
        reject(error)
      });
    });
  },
  verifyIfVendorNameExists: function (context, name) {
    return new Promise((resolve, reject) => {
      Vue.http.get('vendor/checkIfNameExists?vendorName=' + name).then(function (data) {
        resolve(data.data.Data);
      }).catch((error) => {
        reject(error)
      });
    });
  },
  deleteVendorInformation: function (context, vendorInfo) {
    return new Promise((resolve, reject) => {
      Vue.http.delete('vendor/delete/' + vendorInfo.VendorId).then(function (data) {
        resolve(data);
      }).catch((error) => {
        reject(error)
      });
    });
  },
  addDealerToVendor: function (context, dealerInfo) {

    return new Promise((resolve, reject) => {
      Vue.http.post('vendor/addDealerToVendor', dealerInfo).then(function (data) {
        resolve(data.data.Data);
      }).catch((error) => {
        reject(error)
      });
    });
  },
  deleteDealerFromVendor: function (context, apDomainID) {
    return new Promise((resolve, reject) => {
      Vue.http.delete('vendor/deleteDealerFromVendor/' + apDomainID).then(function (data) {
        resolve(data);
      }).catch((error) => {
        reject(error)
      });
    });
  }

};

const mutations = {

  updateVendorsList: function (state, data) {
    state.WebsiteVendorsList = data;
  },
  toggleEditVendorModal: function (state, data) {
    state.showEditVendorModal = data;
  },
  editVendorDetails: function (state, data) {
    state.CurrentVendorDetails = data;
  },
  updateVendorDomainList(state, data) {
    state.VendorDomainList = data;
  },
  toggleViewVendorDomainsModal(state, data) {
    state.showVendorDomainsModal = data;
  },
  updateCurrentVendor(state, data) {
    state.CurrentVendor = data;
  },
  updateSearchItems: function (state, data) {
    state.AD_AccountSearchResults = data;
  },
  toggleAddDealerToVendorModal: function (state, data) {
    state.showAddDealerToVendorModal = data;
  },
  updatePlatforms: function (state, data) {
    state.ActivePlatforms = data;
  },
  toggleDeleteVendorModal: function (state, data) {
    state.showDeleteVendorModal = data;
  },
  updateVendorLoadingImg: function (state, data) {
    state.VendorListLoading = data;
  },
  updateVendorModalType: function (state, data) {
    state.VendorModalType = data;
  },
  updateExistignDomains: function (state, data) {
    state.ExistingDomains = data;
  },
  setViewOnlyPermissions: function (state, data) {
    state.viewOnlyPermissions = data;
  }
};

const getters = {
  WebsiteVendorsList: function () {
    return state.WebsiteVendorsList;
  },
  showEditVendorModal: function () {
    return state.showEditVendorModal;
  },
  CurrentVendorDetails: function () {
    return state.CurrentVendorDetails;
  },
  VendorDomainList: function () {
    return state.VendorDomainList;
  },
  showVendorDomainsModal: function () {
    return state.showVendorDomainsModal;
  },
  CurrentVendor: function () {
    return state.CurrentVendor;
  },
  AD_AccountSearchResults: function () {
    return state.AD_AccountSearchResults;
  },
  showAddDealerToVendorModal: function () {
    return state.showAddDealerToVendorModal;
  },
  ActivePlatforms: function () {
    return state.ActivePlatforms;
  },
  showDeleteVendorModal: function () {
    return state.showDeleteVendorModal;
  },
  VendorListLoading: function () {
    return state.VendorListLoading;
  },
  VendorModalType: function () {
    return state.VendorModalType;
  },
  ExistingDomains: function () {
    return state.ExistingDomains;
  },
  viewOnlyPermissions: function () {
    return state.viewOnlyPermissions;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/WebsiteVendors.js